import { Card } from '@ui/themed';
import { t } from 'i18next';
import { Upsell } from '../../../components/upsell';
import { useHandlers, useSite } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';
import { DISCOUNTS_LEARN_MORE_URL } from '../views/discounts-list-page';

export function DiscountsUpsell() {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  const FEATURE_ITEMS = [
    {
      key: 'discount_types',
      title: t('features:discounts.components.discounts_upsell.features.discount_types.title'),
      description: t(
        'features:discounts.components.discounts_upsell.features.discount_types.description',
      ),
    },
    {
      key: 'targeted_discounts',
      title: t('features:discounts.components.discounts_upsell.features.targeted_discounts.title'),
      description: t(
        'features:discounts.components.discounts_upsell.features.targeted_discounts.description',
      ),
    },
    {
      key: 'reward_discounts',
      title: t('features:discounts.components.discounts_upsell.features.reward_discounts.title'),
      description: t(
        'features:discounts.components.discounts_upsell.features.reward_discounts.description',
      ),
    },
  ];

  return (
    <Card>
      <Upsell
        title={t('features:discounts.components.discounts_upsell.title')}
        subtitle={t('features:discounts.components.discounts_upsell.subtitle')}
        plans={['v2_basic']}
        onClickUpgrade={() => {
          trackUpgradeClicked(site, 'Discounts');
          navigationHandler.navigateById('plan');
        }}
        onClickLearn={() =>
          navigationHandler.navigate(DISCOUNTS_LEARN_MORE_URL, {
            absolute: true,
            newTab: true,
          })
        }
        details={{
          foreword: t('features:discounts.components.discounts_upsell.intro'),
          use_cases: FEATURE_ITEMS,
          learnMoreURLText: t('features:discounts.components.discounts_upsell.learn_more'),
        }}
      />
    </Card>
  );
}
